import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { FunctionCategory } from './function-category.interface';

export class FunctionCategoryService {
   async getFunctionCategories(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<FunctionCategory>>>('/function-categories', {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }

   async getFunctionCategory() {
      throw Error('Method not implemented');
   }

   async postFunctionCategory() {
      throw Error('Method not implemented');
   }

   async putFunctionCategory() {
      throw Error('Method not implemented');
   }

   async deleteFunctionCategory() {
      throw Error('Method not implemented');
   }
}
